import { useGetGBPAlertsMutation, useGetInventoryAlertsMutation, useGetGBPFiltersMutation, useGetDropdownPopupMutation } from "../api/homeApi";

export const useGBPAlerts = () => {
  const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetGBPAlertsMutation();

  return {
    mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  };
};

export const useInventoryAlerts = () => {
  const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetInventoryAlertsMutation();

  return {
    mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  };
};

export const useGBPFilters = () => {
  const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetGBPFiltersMutation();

  return {
    mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  };
};

export const useGetPopup = () => {
  const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetDropdownPopupMutation();

  return {
    mutate,
    isLoading,
    isSuccess,
    isError,
    error,
    data,
  };
};
